import React, { useState } from "react";
import Header from "../Component/Header";
import Breadcrumb from "../Component/Breadcrumb";
import Footer from "../Component/Footer";
import LazyLoad from "react-lazyload";
import FormAdmissionClassXI from "../Component/FormAdmissionClassXI";
import { Link ,useNavigate} from "react-router-dom";
const StudentInfo = () => {
  const [showFormXI, setShowFormXI] = useState(false);
  const handleOpenFormXI = () => setShowFormXI(true);
  const handleCloseFormXI = () => setShowFormXI(false);
  
  

 

  return (

    
    <>
      <Header />
      {showFormXI && <FormAdmissionClassXI onClose={handleCloseFormXI} />}
      <Breadcrumb
        title="  Student Admission"
        tabName="  Student Admission"
      />
      <div className="innerPage">
        <div className="container">
          <div className="row g-3">
            <div className="col-12">
              <Link to='/admission-procedure'>
                <button className="handleOpenFormXI" >
                  Admission Procedure
                </button>
              </Link>
            </div>
            <div className="col-xl-9">
              <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/admission_procedure.jpeg" style={{ height: "700px", margin: "auto", display: "block" }} />
            </div>

            <div className="col-xl-3">
  <div className="class-list">
  <ul>
  {/* GRADE 11 stays normal */}
  <li className="span-2 blue">
    <Link to="/admission-classxi" className="class-link">
      GRADE-11
    </Link>
  </li>

  <li className="span-2 orange">
    <Link
      to="/admission-procedure"
      state={{ grade: "NURSERY" }}
      className="class-link"
    >
      NURSERY
    </Link>
  </li>

  <li className="span-2 center orange">
    <Link
      to="/admission-procedure"
      state={{ grade: "GRADE-9" }}
      className="class-link"
    >
      GRADE-9
    </Link>
  </li>

  <li className="blue">
    <Link
      to="/admission-procedure"
      state={{ grade: "GRADE-7" }}
      className="class-link"
    >
      GRADE-7
    </Link>
  </li>

  <li className="blue">
    <Link
      to="/admission-procedure"
      state={{ grade: "GRADE-8" }}
      className="class-link"
    >
      GRADE-8
    </Link>
  </li>

  <li className="blue">
    <Link
      to="/admission-procedure"
      state={{ grade: "GRADE-5" }}
      className="class-link"
    >
      GRADE-5
    </Link>
  </li>

  <li className="blue">
    <Link
      to="/admission-procedure"
      state={{ grade: "GRADE-6" }}
      className="class-link"
    >
      GRADE-6
    </Link>
  </li>

  <li className="blue">
    <Link
      to="/admission-procedure"
      state={{ grade: "GRADE-3" }}
      className="class-link"
    >
      GRADE-3
    </Link>
  </li>

  <li className="blue">
    <Link
      to="/admission-procedure"
      state={{ grade: "GRADE-4" }}
      className="class-link"
    >
      GRADE-4
    </Link>
  </li>

  <li className="blue">
    <Link
      to="/admission-procedure"
      state={{ grade: "GRADE-1" }}
      className="class-link"
    >
      GRADE-1
    </Link>
  </li>

  <li className="blue">
    <Link
      to="/admission-procedure"
      state={{ grade: "GRADE-2" }}
      className="class-link"
    >
      GRADE-2
    </Link>
  </li>

  <li className="blue">
    <Link
      to="/admission-procedure"
      state={{ grade: "LKG" }}
      className="class-link"
    >
      LKG
    </Link>
  </li>

  <li className="blue">
    <Link
      to="/admission-procedure"
      state={{ grade: "HKG" }}
      className="class-link"
    >
      HKG
    </Link>
  </li>
</ul>
  </div>
</div>





          </div>
          {/* <div className="col-md-8">
              <h3>
                Admission to <span>Holy Spirit Pre-Primary School</span>
              </h3>
              <ul className="list-view">
                <li>
                  
                  Admission to this School is restricted by condition of age,
                  ability and conduct. Applicants for admission will be
                  carefully selected.
                </li>
                <li>
                  
                  The age criteria for Nursery Class is between 3 to 4
                  years.
                </li>
                <li>
                  For all the admissions to kindergarten classes ORIGINAL birth
                  certificate with a photostat copy of Birth Certificate duly
                  attested should be produced in the office. (Original birth
                  certificate is returned to the parents after verification of
                  the documents). At the time of admission, the students should
                  be introduced personally by their parents/guardian who will be
                  responsible for their studies, fees, conduct and
                  discipline.
                </li>
                <li>
                  The Principal/Head Mistress reserves to herself the right of
                  admission.
                </li>
                <li>
                  For more information on admission kindly contact the school
                  office.
                </li>
              </ul>

              <h3>NURSERY FORMS for Session 2026-2027</h3>
              <p>
                NURSERY CLASS Registration form will be available ONLINE on
                School website and on below mentioned campuscare10x link.
              </p>
              <p>
                <b>ONLINE REGISTRATION FORM will be available from:</b>
              </p>

              <p>
                <b>
                  01st December 2025 at 10 am till 5th December 2025 upto 11 pm.
                </b>
              </p>
              <p>
                <b>
                  The link for registration form will be available at:
                  <a href="https://entab.online/ncsraj" target="_blank">
                    https://entab.online/ncsraj
                  </a>
                </b>
              </p>
              <p>
                <b>
                  (Note : The link will be available at above url from 01st
                  December 2025 at 10 am)
                </b>
              </p>

              <p>
                <b>Eligibility:</b> The age of the child seeking admission to
                Nursery Class 2026-27 should be between 3 years and 4 years as
                on 01 June, 2026. If your child is NOT within the age limit
                specified, she will not be eligible for admission.
              </p>
            </div>
            <div className="col-md-4">
              <p>Procedure to fill the online registration form: -</p>
              <a
                data-magnify="gallery"
                data-src=""
                data-group="a"
                href="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/admission-registration.png"
              >
                <LazyLoad>
                  
                  <img
                    src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/NCSR/public/Images/admission-registration.png"
                    class="img-fluid admissionimg"
                    alt=" Children's Convent School Rajkot"
                  />
                </LazyLoad>
              </a>
              <p>
                For more details: Read the guideline attached in Latest News/
                Highlights section.
              </p>
            </div> */}
        </div>
      </div>
      <Footer />
    </>
  );
};
export default StudentInfo;
